export default {"src":"/_next/static/media/ArrowsLeftRight.2bd97b9a.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};